module.exports = __webpack_public_path__ + "static/avatar_jason_ackerman-6877e0a4ad7ea2aca16874de51e56144.jpg";